import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { isNone } from "@ember/utils"

export default function embeddedBelongsTo(path, relationshipType) {
  var ObjectPromiseProxy = ObjectProxy.extend(PromiseProxyMixin)
  return computed(path, function () {
    let id = get(this, path)
    if (isNone(id)) return
    if (
      this[path + relationshipType] &&
      this[path + relationshipType].value === get(this, path) + relationshipType
    ) {
      return this[path + relationshipType].proxy
    }
    this[path + relationshipType] = {
      value: get(this, path) + relationshipType,
      proxy: ObjectPromiseProxy.create({
        promise: get(this, "store").find(relationshipType, id),
      }),
    }
    return this[path + relationshipType].proxy
  })
}
